import { render, staticRenderFns } from "./RequisitionCreateForm.vue?vue&type=template&id=f524b4a8"
import script from "./RequisitionCreateForm.vue?vue&type=script&lang=js"
export * from "./RequisitionCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports